/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerDatabaseBaseSourceComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerSchema',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerSchema) {
      function DesignerDatabaseBaseSourceComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.ACCESS_MODE = {
          TABLE: 'table',
          QUERY: 'query',
        };

        this.access_mode = this.ACCESS_MODE.TABLE;
        this.database_connection_id = null;
        this.schema_name = null;
        this.table_name = null;
        this.where_clause = null;
        this.query = null;
      }

      DesignerDatabaseBaseSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerDatabaseBaseSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          database_connection_id: String(this.connection.id || ''),
          access_mode: this.access_mode || this.ACCESS_MODE.TABLE,
          schema_name: this.schema_name || '',
          table_name: this.table_name || '',
          where_clause: this.where_clause || '',
          query: this.query || '',
        });

        return data;
      };

      DesignerDatabaseBaseSourceComponent.prototype.setFormData = function (data) {
        if (data.access_mode === this.ACCESS_MODE.TABLE) {
          data.query = '';
        } else if (data.access_mode === this.ACCESS_MODE.QUERY) {
          data.schema_name = '';
          data.table_name = '';
          data.where_clause = '';
        }

        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerDatabaseBaseSourceComponent.prototype.setData = function (data) {
        this.database_connection_id = String(data.connection ? data.connection.id : '');
        this.access_mode = data.access_mode;
        this.table_name = data.table_name;
        this.schema_name = data.schema_name;
        this.where_clause = data.where_clause;
        this.query = data.query;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerDatabaseBaseSourceComponent.prototype.getSchema = function () {
        return DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);
      };

      return DesignerDatabaseBaseSourceComponent;
    },
  ]);
})(window.angular);
